import { render, staticRenderFns } from "./SharingOptionPill.vue?vue&type=template&id=216523fc"
import script from "./SharingOptionPill.vue?vue&type=script&lang=js"
export * from "./SharingOptionPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports